import { faEdit, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { InvertButton, PrimaryButton } from 'component-library';
import { useState } from 'react';
import { System, SystemDetail } from '../../../models/ApiModels';
import Modal from '../../../utils/Modal';
import PermissionsGate, { ROLES } from '../../../utils/PermissionGate';
import SystemDetailsBoatInfo from './SystemDetailsBoatInfo';

interface SystemDetailsConnectBoatModelToSystemModalProps {
  system: SystemDetail;
  oldSystem: SystemDetail;
  setSystem: (system: System) => void;
  DiscardChanges: () => void;
  updateSystemAndClose: (updatedSystem: SystemDetail) => void;
  hasChanged: boolean;
}

export const SystemDetailsConnectBoatModelToSystemModal = ({
  system,
  setSystem,
  DiscardChanges,
  updateSystemAndClose,
  hasChanged,
}: SystemDetailsConnectBoatModelToSystemModalProps) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className='p-4 w-full h-full flex flex-col justify-center items-center'>
      <div>No boat model assigned to this system</div>
      <PermissionsGate roles={[ROLES.admin, ROLES.editor, ROLES.oemAdmin, ROLES.oemEditor]}>
        <PrimaryButton onClick={() => setShowModal(true)} label='Assign Boat Model' icon={faPlus} />
        {showModal && (
          <AssignBoatModelModal
            DiscardChanges={DiscardChanges}
            system={system}
            setSystem={setSystem}
            setShowModal={setShowModal}
            updateSystemAndClose={updateSystemAndClose}
            hasChanged={hasChanged}
          />
        )}
      </PermissionsGate>
    </div>
  );
};

interface AssignBoatModelModalProps {
  system: SystemDetail;
  setSystem: (system: System) => void;
  setShowModal: (show: boolean) => void;
  DiscardChanges: () => void;
  updateSystemAndClose: (updatedSystem: SystemDetail) => void;
  hasChanged: boolean;
}
const AssignBoatModelModal = ({
  system,
  setShowModal,
  setSystem,
  DiscardChanges,
  updateSystemAndClose,
  hasChanged,
}: AssignBoatModelModalProps) => {
  return (
    <>
      <Modal>
        <SystemDetailsBoatInfo system={system} setSystem={setSystem} editMode={true} />
        <div className='flex items-center gap-4 justify-between'>
          <InvertButton
            label='Cancel'
            onClick={() => {
              DiscardChanges();
              setShowModal(false);
            }}
          />
          <PrimaryButton
            label='Save boat information'
            disabled={!hasChanged}
            icon={faEdit}
            onClick={() => updateSystemAndClose(system)}
          />
        </div>
      </Modal>
    </>
  );
};
